import type { NavEntry, NavNodeWithPath } from './types';

/**
 * Build breadcrumb trail for a given entry using stored parent information
 */
function buildBreadcrumbs(entry: NavEntry): Array<{ name: string; path: string }> {
  const crumbs: Array<{ name: string; path: string }> = [];

  // Add all stored parents (names are always provided)
  if (entry.parents) {
    for (const parent of entry.parents) {
      crumbs.push({
        path: parent.path,
        name: parent.name,
      });
    }
  }

  // Add the entry itself as the final breadcrumb
  crumbs.push({ path: entry.path, name: entry.name });

  return crumbs;
}

export function mapNavEntriesToNavNodesWithPath(entries: NavEntry[], limit: number): NavNodeWithPath[] {
  const limited = entries.slice(0, limit);

  // Convert to NavNodeWithPath format for compatibility with existing components
  return limited.map((entry) => ({
    node: {
      name: entry.name,
      path: entry.path,
      lastVisited: entry.lastVisited,
      type: entry.type,
      children: [],
      pinned: entry.pinned,
    },
    breadcrumbs: buildBreadcrumbs(entry),
  }));
}
